.sn-long-content-type-4 {
  &__main {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-lg);
  }

  &__sidebar {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl);
  }

  .how-it-works--subtitle {
    margin-top: 28px;

    @include desktop {
      margin-top: 60px;
    }
  }
}
